import { configs } from '@/constants'
import { dispatch } from '@/store'
import { setProfile } from '@/store/user.store'
import { notice } from '@/utils'
import { cookie, storage } from '@/utils/storage'
import { type Account, Roles } from '@prisma/client'

import axios from '../axios'
import { tryCatch } from '../catch'
import { supabaseAuth } from '../supabase'

export class AuthService {
  /**
   * GET user profile.
   */
  static async profile() {
    try {
      const response = await axios.get<Account>(`/v2/users/profile`)
      if (response.data) {
        if ([Roles.ROOT, Roles.ADMIN].indexOf(response.data.role as any) < 0) {
          notice.warn('Permission denied!', { title: 'Warning' })
          this.signOut()
        } else {
          storage.set(configs.APP_USER_INFO, response.data)
          dispatch(setProfile(response.data))
        }
      }
    } catch (error) {
      tryCatch('`AuthService.profile`', error)
    }
  }

  /**
   * Destroy all browser session.
   *
   * @param cb Callback function.
   */
  static async signOut(cb?: () => void) {
    await supabaseAuth.signOut()

    cookie.remove(configs.APP_AUTH_ACCESS)
    cookie.remove(configs.APP_AUTH_REFRESH)
    storage.remove(configs.APP_USER_INFO)

    dispatch(
      setProfile({
        id: 0,
        role: Roles.GUEST,
        avatar: '',
        displayName: ''
      })
    )

    if (cb) setTimeout(cb, 64)
  }
}
